document.addEventListener('DOMContentLoaded', function () {
  const progressBarItems = document.querySelectorAll('.progress-bar li');
  const descriptionListItems = document.querySelectorAll('.description-list li');
  let isHovered = false;
  let timeoutId;

  // Show only the initially active item
  const initiallyActiveIndex = Array.from(descriptionListItems).findIndex(item => item.classList.contains('is-active'));
  descriptionListItems.forEach((descriptionListItem, index) => {
    descriptionListItem.style.display = index === initiallyActiveIndex ? 'block' : 'none';
  });

  progressBarItems.forEach((progressBarItem, index) => {
    progressBarItem.addEventListener('mouseover', () => {
      showDescriptionItem(index);
      isHovered = true;
      clearTimeout(timeoutId);
    });

    progressBarItem.addEventListener('touchstart', (event) => {
      event.preventDefault(); // Prevent the click event on touch devices
      showDescriptionItem(index);
      isHovered = true;
      clearTimeout(timeoutId);
    });

    progressBarItem.addEventListener('mouseout', () => {
      isHovered = false;
      scheduleHideDescriptionItem(initiallyActiveIndex);
    });
  });

  function showDescriptionItem(index) {
    // Hide all description list items
    descriptionListItems.forEach((descriptionListItem) => {
      descriptionListItem.style.display = 'none';
    });

    // Show the corresponding description list item
    descriptionListItems[index].style.display = 'block';
  }

  function scheduleHideDescriptionItem(index) {
    timeoutId = setTimeout(() => {
      if (!isHovered) {
        // Hide the description list item after the delay
        descriptionListItems.forEach((descriptionListItem) => {
          descriptionListItem.style.display = 'none';
        });

        // Show the initially active item
        descriptionListItems[index].style.display = 'block';
      }
    }, 500); // Set your desired delay time in milliseconds
  }
});
